import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import List from './List';
import ListPager from './ListPager';
import Loader from './Loader';
import { AJAX_URL } from '../../config/index.js';

let pageWasInteractedWith = false;

export default function MagazineList() {
  const [isLoading, setLoading] = useState(true);
  const [magazineList, setMagazineList] = useState([]);
  const [query, setQuery] = useState({ selected_year: 0 });

  // hacky way to prevent the automatic scroll-trigger to top of container on pageload.. guys..
  $(document).one('click', () => {
    pageWasInteractedWith = true;
  });

  // Pagination State
  const [limit, setLimit] = useState(12);
  const [pagerIndex, setPagerIndex] = useState(0);
  const [paginatedMagazines, setPaginatedMagazines] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const handlePagination = (list, currentIndex) => {
    setTotalPages(Math.ceil(list.length / limit));

    const startIndex = limit * currentIndex;
    const endIndex = startIndex + limit;
    const selection = list.slice(startIndex, endIndex);

    setPaginatedMagazines(selection);

    // Scroll to top of container after changing pagination (settings).
    if (pagerIndex || (!pagerIndex && pageWasInteractedWith)) {
      const scrollOffset = document.body.classList.contains('admin-bar')
        ? 105
        : 70;

      window.scrollTo({
        top:
          window.pageYOffset +
          parseInt(
            document.getElementById('magazine-app').getBoundingClientRect().top
          ) -
          scrollOffset,
        behavior: 'smooth'
      });
    }
  };

  const prevPage = () => {
    setPagerIndex(pagerIndex - 1);
  };

  const nextPage = () => {
    setPagerIndex(pagerIndex + 1);
  };

  useEffect(() => {
    const fetchMagazines = async (query) => {
      await $.ajax({
        type: 'POST',
        url: `${AJAX_URL}post_wl_query_magazines`,
        dataType: 'json',
        encode: true,
        data: query,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then((res) => {
          res.data.sort(
            (a, b) => new Date(b.full_date) - new Date(a.full_date)
          );
          setMagazineList(res.data);
        })
        .catch((err) => console.log(err.message));
    };
    fetchMagazines(query);
    setPagerIndex(0);
  }, [query, limit]);

  useEffect(() => {
    magazineList.length > 0 ? setLoading(false) : '';
    handlePagination(magazineList, pagerIndex);
  }, [magazineList]);

  useEffect(() => {
    handlePagination(magazineList, pagerIndex);
  }, [pagerIndex, limit]);

  return (
    <div style={{ marginTop: '50px' }}>
      <div className="container container--xl">
        <div className="grid grid--std">
          <div className="grid__col-xs-12">
            <div className="section__header relative">
              <h4 className="section__header-text">Magazine Archives</h4>
              <YearSelector query={query} setQuery={setQuery} />
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div style={{ minHeight: '1120px' }}>
          <Loader />
        </div>
      ) : (
        <section className="section u--padding-0">
          <List magazineList={paginatedMagazines} />
          <ListPager
            changeLimit={setLimit}
            limit={limit}
            setPagerIndex={setPagerIndex}
            nextPage={nextPage}
            prevPage={prevPage}
            pagerIndex={pagerIndex}
            totalItems={magazineList.length}
            totalPages={totalPages}
            paginatedItemCount={paginatedMagazines.length}
          />
        </section>
      )}
    </div>
  );
}

function YearSelector({ query, setQuery }) {
  const [years, setYears] = useState([]);

  useEffect(() => {
    const fetchIssueYears = async () => {
      await $.ajax({
        type: 'POST',
        url: `${AJAX_URL}post_wl_query_magazine_issue_years`,
        dataType: 'json',
        encode: true,
        data: {},
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then((res) => {
          setYears(res.data);
        })
        .catch((err) => console.log(err.message));
    };
    fetchIssueYears();
  }, []);

  return (
    <div className="pagination__section pagination__section--year-input">
      <div className="pagination__results-per-page">
        <div className="pagination__results-label u--hidden-xs">Year:</div>
        <div className="pagination__results-input-wrapper">
          <select
            onChange={(e) => {
              setQuery({ selected_year: parseInt(e.target.value) });
            }}
            className="pagination__results-input"
          >
            <option defaultValue={query}>All</option>
            {years &&
              years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
          </select>
          <i className="icon-caret-down"></i>
        </div>
      </div>
    </div>
  );
}
